// extracted by mini-css-extract-plugin
module.exports = {"checkboxForm":"ContentCardCheckbox-module_checkboxForm_3uCeD"};